import { Component, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: "app-processing-view",
  templateUrl: "./processing-view.component.html",
  styleUrl: "./processing-view.component.scss",
})
export class ProcessingViewComponent implements OnInit, OnDestroy {
  private disableBodyScroll(): void {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
  }

  private enableBodyScroll(): void {
    document.body.style.overflow = "inherit";
    document.body.style.height = "inherit";
  }
  ngOnInit() {
    this.disableBodyScroll();
  }
  ngOnDestroy(): void {
    this.enableBodyScroll();
  }
}
